<h2 mat-dialog-title class="confirm-title">{{ data.title }}</h2>
<div mat-dialog-content class="confirm-message">{{ data.message }}</div>
<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close(false)">{{ data.cancelText || 'Cancel' }}</button>
  @if (data.destructive) {
    <button mat-raised-button color="warn" cdkFocusInitial (click)="dialogRef.close(true)">
      {{ data.confirmText || 'Confirm' }}
    </button>
  } @else {
    <button mat-raised-button color="primary" cdkFocusInitial (click)="dialogRef.close(true)">
      {{ data.confirmText || 'Confirm' }}
    </button>
  }
</mat-dialog-actions>
